import request from './.request'
/**
 * 明天起到指定日期的区间内，全公司的用工量
 * @param {number} enterpriseId 
 * @param {number} to 
 * @returns 
 */
export function getLaborPlanByEnterpriseId(enterpriseId, to) {
  return request({
    url: `/labor-plan/${enterpriseId}?by=enterprise&to=${to}`,
    method: 'get',
  })
}

/**
 * 明天起到指定日期的区间内，具体园区的用工量
 * @param {number} parkId 
 * @param {number} to 
 * @returns 
 */
export function getLaborPlanByParkId(parkId, to) {
  return request({
    url: `/labor-plan/${parkId}?by=park&to=${to}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/labor-plan.js